import { NodeViewWrapper } from '@tiptap/react';
import React from 'react';
import { Chip, createUseStyles, useClasses } from '@Sage/hoi-poi-ui';
import classnames from 'classnames';

import styles from './styles';
const useStyles = createUseStyles(styles, 'VariableRichText');

export default ({ node, extension }) => {
    const classes = useClasses(useStyles);
    const variable = extension?.options?.variableMap?.[node.attrs.key];
    if (!variable) return null;
    return (
        <NodeViewWrapper className={classnames('fm-richtext__variable', classes.root)}>
            <Chip icon={variable?.icon} isActive className={classes.chip}>
                {variable?.label}
            </Chip>
        </NodeViewWrapper>
    );
};
